import {FC} from 'react'
import {uploadTemplateService} from '../../services/uploadTemplate'
import {ShowSnackBar} from '../../../../../../util/functions'
import {ERROR_MESSAGE_SYSTEM} from '../../../../../../util/Constants'
import {getTemplateModuleService} from '../../services'
import {MasiveUploadHoteleria} from '../../../../../../components/UI/Form/MasiveHoteleria'
const FormMasiveUploadModule: FC = () => {
  const handleUpload = async (formData: FormData) => {
    try {
      const data = await uploadTemplateService(formData) // Use the service to upload the file
      return data
    } catch (error) {
      console.error('Error uploading file:', error)
      // ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    }
  }

  return (
    <MasiveUploadHoteleria
      serviceTemplate={getTemplateModuleService}
      handleSendService={handleUpload}
      showModalList
      title='Modulos'
    />
  )
}

export {FormMasiveUploadModule}
